
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27.084","height":"35.341"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 11326"}},[_c('g',{attrs:{"data-name":"Group 11282","fill":"#fff","stroke":"#464646","stroke-miterlimit":"10","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M16.495 6.419A5.669 5.669 0 1110.826.75h0a5.661 5.661 0 015.669 5.635v.034z"}}),_c('path',{attrs:{"data-name":"Path 529","d":"M15.61 31.361H6.041A5.291 5.291 0 01.75 26.07v-3.718a10.076 10.076 0 0110.076-10.076h0a10.076 10.076 0 0110.075 10.076v3.718a5.291 5.291 0 01-5.291 5.291z"}})]),_c('g',{attrs:{"data-name":"Group 11288","transform":"translate(-1498.36 -341.25)"}},[_c('circle',{attrs:{"data-name":"Ellipse 614","cx":"9.796","cy":"9.796","r":"9.796","transform":"translate(1505.853 357)","fill":"#464646"}}),_c('g',{attrs:{"data-name":"Group 11285","transform":"translate(1513.989 360.608)","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 8346","d":"M1.55 12.482A1.152 1.152 0 01.398 11.33V5.075A1.152 1.152 0 011.55 3.923a1.152 1.152 0 011.152 1.152v6.255a1.152 1.152 0 01-1.152 1.152z"}}),_c('circle',{attrs:{"data-name":"Ellipse 612","cx":"1.66","cy":"1.66","r":"1.66"}})])])])])
          )
        }
      }
    